import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  operation: 'now',
  format: 'yyyy-MM-dd HH:mm:ss',
  value: 1,
  unit: 'days',
};

export default defaults;
